import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { LayoutContext } from '../../context/LayoutProvider';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & p.section_title {
    font-size: ${props => props.theme.fontSize['32']};
    font-weight: 700;
    & > * {
      font-size: inherit;
      font-weight: inherit;
    }
  }
  ${props =>
    props.isMobile
      ? css`
          width: 100vw;
          height: 100vh;
        `
      : css`
          width: 100%;
          height: auto;
        `}
`;

const InnerContainer = ({ children, ...other }) => {
  const { isMobile } = useContext(LayoutContext);

  return (
    <Container isMobile={isMobile} {...other}>
      {children}
    </Container>
  );
};

InnerContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,
};

export default InnerContainer;
